import { useI18n } from '../../lib/i18n'
import Chapter1 from './Chapter1'
import Chapter2 from './Chapter2'
import Chapter3 from './Chapter3'
import Chapter4 from './Chapter4'
import Chapter5 from './Chapter5'
import Chapter6 from './Chapter6'
import Chapter7 from './Chapter7'
import Chapter8 from './Chapter8'
import Chapter9 from './Chapter9'
import Chapter10 from './Chapter10'

interface TocItem {
  id: string
  cs: string
  en: string
}

const TOC_ITEMS: TocItem[] = [
  { id: 'kap-1', cs: '1. Jak ShowX přemýšlí', en: '1. How ShowX thinks' },
  { id: 'kap-2', cs: '2. Hlavní okno', en: '2. Main window' },
  { id: 'kap-3', cs: '3. Cues a payloady prakticky', en: '3. Cues and payloads in practice' },
  { id: 'kap-4', cs: '4. Stanice a pairing', en: '4. Stations and pairing' },
  { id: 'kap-5', cs: '5. REHEARSAL vs SHOW', en: '5. REHEARSAL vs SHOW' },
  { id: 'kap-6', cs: '6. Multi-operator provoz', en: '6. Multi-operator operation' },
  { id: 'kap-7', cs: '7. EventX Bridge modul', en: '7. EventX Bridge module' },
  { id: 'kap-8', cs: '8. Ovládání agentem (MCP)', en: '8. Agent control (MCP)' },
  { id: 'kap-9', cs: '9. Nasazení do reálu', en: '9. Production deployment' },
  { id: 'kap-10', cs: '10. Troubleshooting', en: '10. Troubleshooting' },
]

export function Prirucka() {
  const { lang } = useI18n()
  const cs = lang === 'cs'

  return (
    <div>
      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-12 pt-24 lg:pt-32 pb-20">
          <div className="grid grid-cols-12 gap-6 items-end">
            <div className="col-span-12 lg:col-span-9 animate-fade-up">
              <div className="section-label mb-8">
                {cs ? 'Příručka operátora' : "Operator's Handbook"}
              </div>
              <h1 className="display-serif text-display-1 text-ink leading-[0.95]">
                ShowX v0.8.0
                <br />
                <em className="font-light text-accent-deep not-italic">
                  {cs ? 'od přípravy k GO' : 'from prep to GO'}
                </em>
              </h1>
              <p className="copy text-lg mt-10 max-w-2xl">
                {cs
                  ? 'Narativní průvodce pro Stage Managery a operátory. Jak ShowX přemýšlí, jak připravit show, jak ji řídit na živé produkci.'
                  : 'Narrative guide for Stage Managers and operators. How ShowX thinks, how to build a show, how to run it live.'}
              </p>
            </div>
          </div>
        </div>
        <div className="absolute -bottom-10 -right-20 display-serif text-[18rem] leading-none text-accent/[0.08] select-none pointer-events-none">
          PR
        </div>
      </section>

      {/* CONTENT — Sidebar TOC + chapters */}
      <section className="rule-top">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-12 py-20">
          <div className="grid grid-cols-12 gap-8">
            {/* TOC */}
            <aside className="prirucka-toc col-span-12 lg:col-span-3 lg:sticky lg:top-24 lg:self-start">
              <div className="section-label mb-4">{cs ? 'Obsah' : 'Contents'}</div>
              <ul className="space-y-2 text-sm">
                {TOC_ITEMS.map(item => (
                  <li key={item.id}>
                    <a
                      href={`#${item.id}`}
                      className="text-muted hover:text-ink underline decoration-1 underline-offset-4 decoration-transparent hover:decoration-current transition-colors"
                    >
                      {cs ? item.cs : item.en}
                    </a>
                  </li>
                ))}
              </ul>
            </aside>

            {/* Chapters */}
            <div className="prirucka-content col-span-12 lg:col-span-9 space-y-20">
              <Chapter1 cs={cs} />
              <Chapter2 cs={cs} />
              <Chapter3 cs={cs} />
              <Chapter4 cs={cs} />
              <Chapter5 cs={cs} />
              <Chapter6 cs={cs} />
              <Chapter7 cs={cs} />
              <Chapter8 cs={cs} />
              <Chapter9 cs={cs} />
              <Chapter10 cs={cs} />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
